<template>
  <div>
    <v-app-bar :app="$vuetify.breakpoint.width > 890" color="black" dark elevate-on-scroll class="pl-12 manu-container">
      <v-toolbar-title class="pl-4">
        <router-link to="/">
          <v-img class="logo-image" src="@/assets/images/Rectangle 3.png" alt="Logo" contain height="40"></v-img>
        </router-link>
      </v-toolbar-title>

      <!-- Navegação por ícones (desktop) -->
      <div class="nav" v-if="!isMobile">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon to="/" class="nav-button" v-bind="attrs" v-on="on">
              <img src="@/assets/images/home.png" alt="Home" class="nav-icon-img" />
            </v-btn>
          </template>
          <span>Home</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon to="/descobrir" class="nav-button nav-button--discover" v-bind="attrs" v-on="on">
              <img src="@/assets/images/descobrir.png" alt="Descobrir" class="nav-icon-img" />
            </v-btn>
          </template>
          <span>Descobrir</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon to="/portal-zinnes" class="nav-button" v-bind="attrs" v-on="on">
              <img src="@/assets/images/comunidade.png" alt="Portal Zinnes" class="nav-icon-img" />
            </v-btn>
          </template>
          <span>Portal Zinnes</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon to="/marketplace" class="nav-button" v-bind="attrs" v-on="on">
              <img src="@/assets/images/carrinho.png" alt="Marketplace" class="nav-icon-img" />
            </v-btn>
          </template>
          <span>Marketplace</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon to="/zinnes" class="nav-button nav-button--zinnes" v-bind="attrs" v-on="on">
              <img src="@/assets/images/zinnes.png" alt="Originais Zinnes" class="nav-icon-img" />
            </v-btn>
          </template>
          <span>Originais Zinnes</span>
        </v-tooltip>
      </div>

      <v-spacer></v-spacer>
      <v-btn icon to="/notifications">
        <v-icon>mdi-bell-outline</v-icon>
        <v-badge v-show="notifications.length" :content="notifications.length" color="var(--zinnes-primary)" overlap></v-badge>
      </v-btn>
      <template v-if="isMobile">
        <v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>
      </template>

      <template v-else>
        <v-btn class="ml-3 zinnes-primary-btn" rounded large>
          {{ username }}
        </v-btn>
      </template>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app dark>
      <v-list dense>
        <template v-if="!isAuthor && !isAdmin">
          <v-list-item style=" width: 70%; margin: 0 auto;">
            <v-btn class="zinnes-primary-btn" @click="openModal">
              <v-list-item-content>
                <v-list-item-title style="text-align: center;">Quero ser Autor</v-list-item-title>
              </v-list-item-content>
            </v-btn>
          </v-list-item>

          <v-list-item :disabled="true">
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Painel</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <router-link to="/dashboard/user-profiler" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Perfil</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/dashboard/configuracao" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-cog</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Configurações</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="isAuthor && !isAdmin">
          <v-list-item link to="/dashboard/publicar-obra" class="drawer-primary-action">
            <v-list-item-content>
              <v-list-item-title style="text-align: center;">Publicar</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <router-link to="/dashboard/painel" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Painel</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/dashboard/user-profiler" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Perfil</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/dashboard/configuracao" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-cog</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Configurações</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="isAdmin">
          <router-link to="/dashboard/publicar-obra" style="text-decoration: none;">
            <v-list-item class="drawer-primary-action">
              <v-list-item-content>
                <v-list-item-title style="text-align: center;">Publicar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/dashboard/painel" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Painel</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/dashboard/user-profiler" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Perfil</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <v-subheader>ADMINISTRADOR</v-subheader>

          <router-link to="/dashboard/adm_dashboard" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/dashboard/publicar-banner" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-image</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Banners</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/dashboard/adm_moderadores" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-account-group</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Moderadores</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/dashboard/avisos" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-bell</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Avisos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/dashboard/adm_acess_user" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-account-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Usuários</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/dashboard/configuracao" style="text-decoration: none;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-cog</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Configurações</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <template>
      <div>
        <v-dialog v-model="isModalOpen" scrollable full-width>
          <v-card>
            <v-card-title class="headline">Termos e Condições</v-card-title>
            <v-card-text>
              <p class="text">Estamos felizes que você deseja compartilhar suas obras conosco!</p>
              <p class="text">Ao se tornar um autor, você terá a oportunidade de publicar suas obras originais e
                compartilhar suas histórias com a comunidade.</p>

              <h3 class="font-weight-semibold">Termos e Condições:</h3>
              <ul>
                <li>Você concorda em publicar apenas obras autorais.</li>
                <li>Você não deve plagiar ou copiar o trabalho de outros.</li>
                <li>A plataforma não se responsabiliza por qualquer infração de direitos autorais.</li>
              </ul>

              <h3 class="font-weight-semibold">Responsabilidade sobre Plágio:</h3>
              <p class="text">É de sua responsabilidade garantir que as obras que você publica são de sua própria
                autoria.
                Qualquer violação de direitos autorais será de sua responsabilidade.</p>

              <v-checkbox v-model="acceptedTerms"
                label="Eu li e aceito os termos de privacidade e responsabilidade sobre plágio."></v-checkbox>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" @click="cancel">Cancelar</v-btn>
              <v-btn color="primary" @click="confirm" :disabled="!acceptedTerms">Confirmar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

  </div>
</template>

<script>
import NotificationService from '@/server/NotificationService';
import { becomeAuthor } from '@/server/userServe';
import { logout } from '@/server/authServe';
import { getUser } from '@/server/authStorage';

export default {
  name: "HeaderNormal",
  data() {
    return {
      isModalOpen: false, // Controla a visibilidade da modal
      acceptedTerms: false, // Controle do checkbox
      drawer: false,
      isMobile: false,
      isAuthor: true,
      isAdmin: false,
      username: "",
      service: new NotificationService(),
      notifications: new Array(),
      intervalo: null,
    };
  },
  async created() {
    const user = getUser();
    this.username = user ? user.name : "";
    this.getNotification();
    // this.intervalo = setInterval(this.getNotification, 30000)
  },
  methods: {
    async getNotification() {
      if (this.username) {
        this.notifications = await this.service.list({ news: true });
      }
    },
    openModal() {
      this.isModalOpen = true; // Abre o modal
    },
    async confirm() {
      await becomeAuthor();
      await this.setUserAccess();
      this.isModalOpen = false;
    },
    cancel() {
      this.isModalOpen = false; // Fecha o modal
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 890;
    },
    async logout() {
      await logout();
      this.$router.push('/login');
    },

    setUserAccess() {
      const user = getUser();
      if (user) {
        this.isAdmin = user.level === 'GM Guild Master';
        this.isAuthor = user.level === 'OA Administrador';
      }
    },
  },
  mounted() {
    this.setUserAccess();
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
    // clearInterval(this.intervalo); // Remove o intervalo ao destruir o componente
  }
};
</script>

<style scoped>
.menu-container {
  width: 100% !important;
}

.v-app-bar {
  padding: 0 20px;
  z-index: 1000 !important;
}

.v-app-bar ::v-deep .v-toolbar__content {
  z-index: 1001 !important;
}

.v-app-bar ::v-deep .v-app-bar__nav-icon {
  z-index: 1003 !important;
}

.v-btn {
  font-weight: bold;
  font-size: 16px;
  position: relative;
  z-index: 1002;
}

.drawer-primary-action {
  background-color: var(--zinnes-primary) !important;
  border-radius: 12px;
  color: #ffffff !important;
  margin: 0 auto;
  width: 70%;
}

/* Ícones na barra superior (desktop) */
.nav {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-left: 16px;
  position: relative;
  z-index: 1002;
}

.nav-button {
  transition: all 0.3s ease;
  position: relative;
  z-index: 1002;
}

.nav-button .v-icon {
  font-size: 28px !important;
  color: white;
  transition: color 0.3s ease;
  z-index: 1003;
  position: relative;
}

.nav-button:hover .v-icon,
.nav-button.v-btn--active .v-icon {
  color: #FFD700 !important;
}

.nav-icon-img {
  width: 35.28px;
  height: 35.28px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  transition: filter 0.3s ease;
  z-index: 1003;
  position: relative;
}

/* Ícone Zinnes maior (25%) */
.nav-button--zinnes .nav-icon-img {
  width: 42.8px;
  height: 42.8px;
}

/* Ícone Descobrir maior (50%) */
.nav-button--discover .nav-icon-img {
  width: 52.92px;
  height: 52.92px;
}

.nav-button:hover .nav-icon-img,
.nav-button.v-btn--active .nav-icon-img {
  filter: brightness(0) saturate(100%) invert(66%) sepia(99%) saturate(1500%) hue-rotate(0deg) brightness(104%) contrast(101%);
}

.nav-button--zinnes:hover .nav-icon-img,
.nav-button--zinnes.v-btn--active .nav-icon-img {
  filter: brightness(0) saturate(100%) invert(66%) sepia(99%) saturate(1500%) hue-rotate(0deg) brightness(104%) contrast(101%);
}

.v-app-bar ::v-deep .v-badge {
  z-index: 1003 !important;
}

.v-app-bar ::v-deep .v-badge__badge {
  z-index: 1004 !important;
}

.logo-image {
  z-index: 1003;
  position: relative;
}

@media (max-width: 767px) {
  .v-app-bar {
    justify-content: space-between;
    padding: 0 10px;
  }

  .logo-image {
    width: 89px;
    height: 30px;
  }
}

@media (max-width: 520px) {
  .manu-container {
    width: 100% !important;
    left: 0px !important;
  }

  .v-btn {
    height: 20px;
    font-size: 10px;
  }

  .ml-3 {
    height: 20px !important;
    width: 50px !important;
  }
}
</style>
